module.exports = __webpack_public_path__ + "static/media/DistanceMeasurement_002.dbf77aad.jpg";